import { DEFAULT_POOL_PPLNS_COMMISSION, DEFAULT_POOL_PPS_COMMISSION } from 'constants/commission';
import convertFractionToPercent from 'utils/math/convertFractionToPercent';

export const MIN_NAME_LEN = 3;

export const DEFAULT_FORM_VALUES = {
  pps: {
    poolCommission: convertFractionToPercent(DEFAULT_POOL_PPS_COMMISSION, { symbol: false }),
  },

  pplns: {
    poolCommission: convertFractionToPercent(DEFAULT_POOL_PPLNS_COMMISSION, { symbol: false }),
  },
};
